import { render, staticRenderFns } from "./examsets.vue?vue&type=template&id=3f05b6c4&"
import script from "./examsets.vue?vue&type=script&lang=js&"
export * from "./examsets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports